import { environment } from './../environments/environment';
import { StorageListenerService } from './private/services/StorageListener.service';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { NgxSpinnerService } from 'ngx-spinner';
import { IMonths } from './models/IMonths';
import { SearchEvent } from './models/SearchEvent';
import { AppService } from './private/services/app.service';
import { CategoriesService } from './private/services/categories.service';
import { EncrDecrService } from './private/services/encr-decr.service';
import { EventsService } from './private/services/events.service';
import { Subscription } from 'rxjs';
import { MainComponent } from './public/main/main.component';
import { Thumbs } from 'swiper';
import { AdsService } from 'src/app/private/admin/services/ads.service';
import { SponsoredEventsService } from './private/admin/services/sponsored-events.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  @ViewChild('myDiv') myDiv: ElementRef;
  // ===========================================================================
  // VARIABLES AND CONSTANTS
  // ===========================================================================
  title = 'events-management';

  // FORMS
  webSearchForm: FormGroup;
  mobileSearchForm: FormGroup;

  loginForm: FormGroup;
  registerForm: FormGroup;
  forgotPasswordForm: FormGroup;
  // TODO To be implemented when we want to include the country combo box
  // countryFormControl = new FormControl();
  // countryFormGroup: FormGroup;

  // LOGIN FORM VARIABLES ANS CONSTANTS
  loadingLogin: boolean;
  showLoginModal: boolean;
  isLoggedIn = false;

  _eventsListener: Subscription
  _dateRangeEventsListener: Subscription
  // REGISTER FORM VARIABLES ANS CONSTANTS
  loadingRegister: boolean;
  showRegisterModal: boolean;

  // COUNTRIES VARIABLES AND CONSTANTS
  // TODO To be implemented when we want to include the country combo box
  // country: string;
  // countriesSubscribtion: Subscription;
  // predefinedCountries: Country[] = [];

  //CATEGORIES VARIABLES AND CONSTANTS
  categories = [{ id: 0, name: 'All Events' }];
  selectedCategory;
  selectedCategoryName;
  itemsPerSlide = 10;
  singleSlideOffset = false;

  //CALENDER VARIABLES AND CONSTANTS
  allMonths: IMonths[] = [
    { fullName: 'January', name:'JAN', value: 1, isSelected: false },
    { fullName: 'February', name:'FEB', value: 2, isSelected: false },
    { fullName: 'March', name:'MAR', value: 3, isSelected: false },
    { fullName: 'April', name:'APR', value: 4, isSelected: false },
    { fullName: 'May', name:'MAY', value: 5, isSelected: false },
    { fullName: 'June', name:'JUN', value: 6, isSelected: false },
    { fullName: 'July', name:'JUL', value: 7, isSelected: false },
    { fullName: 'August', name:'AUG', value: 8, isSelected: false },
    { fullName: 'September', name:'SEP', value: 9, isSelected: false },
    { fullName: 'October', name:'OCT', value: 10, isSelected: false },
    { fullName: 'November', name:'NOV', value: 11, isSelected: false },
    { fullName: 'December', name:'DEC', value: 12, isSelected: false },
  ];

  minYear = 2012;
  listOfAllYears = [];
  listOfDaysOfTheSelectedMonth = [];
  selectedMonth;
  selectedYear;
  selectedDay;
  currentDate = new Date(); 
  year = this.currentDate.getFullYear();
  startDate: string = ""
  endDate: string = ""

  //EVENTS VARIABLES AND CONSTANTS
  eventsTitle:string;
  // Standard Events Data
  standardEvents: any[] = [];
  // Featured Events Data
  featuredEvents: any[] = [];
  // Sponsored Events Data
  sponsoredEvents: any[] = [];
  // All Events Data
  allEvents: any[] = [];
  // Event Type
  adminAds: any[] = []
  userAds: any[] = []
  allAds: any[] = []
  shuffledUser: any[] = []
  shuffledAdmin: any[] = []
  shuffledAds: any[] = []
  EVENT_TYPE_STANDARD = 'STANDARD';
  EVENT_TYPE_FEATURED = 'FEATURED';
  EVENT_TYPE_SPONSORED = 'SPONSORED';

  //OTHERS VARIABLES AND CONSTANTS
  userImage: string =
    'https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png';
  showForgotPasswordModal: boolean;
  submitted = false;
  options: any = {
    componentRestrictions: {
      country: 'LB',
    },
  };
  showNotification: boolean;
  allPendingEvents: any;
  bookingFeature:boolean = environment.bookingFeature;
  //isUSER, isADMIN OR isSUPERADMIN
  //USER: 1
  //ADMIN: 2
  //SUPER ADMIN: 3
  userType:number;

  dateRange
  startMonth
  endMonth
  search:boolean = false

  daysOfWeek:any = [
  { name:"Monday", value: "Mon"}, 
  { name:"Tuesday", value: "Tue"}, 
  { name:"Wednesday", value: "Wed"}, 
  { name:"Thursday", value: "Thu"}, 
  { name:"Friday", value: "Fri"}, 
  { name:"Saturday", value: "Sat"}, 
  { name:"Sunday",value: "Sun"}
  ]
  

  constructor(
    private formBuilder: FormBuilder,
    private appService: AppService,
    private encDexcService: EncrDecrService,
    public router: Router,
    private encDecrService: EncrDecrService,
    private route: ActivatedRoute,
    private categoryService: CategoriesService,
    private eventsService: EventsService,
    private spinner: NgxSpinnerService,
    private storageListenerService: StorageListenerService,
    private adsService: AdsService,
    private sponsoredEventsService: SponsoredEventsService
  ) {}

  // ===========================================================================
  // OnInit
  // ===========================================================================
  async ngOnInit() {
 
    // -------------------------------------------------------------------------
    // RedirectCall after signin/signup using google/facebook
    // -------------------------------------------------------------------------
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token != null) {
      this.appService
        .redirectCall(token)
        .then((res: any) => {
          this.encDecrService.encryptJsonDataToStorage(
            'user',
            JSON.stringify(res.user)
          );
          this.isLoggedIn = true;
          if (res.user.avatar != null) this.userImage = res.user.avatar;
          this.router.navigate(['main']);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    // -------------------------------------------------------------------------
    // FORMS initialization
    // -------------------------------------------------------------------------
    this.loginForm = this.formBuilder.group({
      emailLogin: ['', [Validators.required, Validators.email]],
      passwordLogin: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.registerForm = this.formBuilder.group({
      firstnameRegister: ['', [Validators.required, Validators.minLength(2)]],
      lastnameRegister: ['', [Validators.required, Validators.minLength(2)]],
      emailRegister: ['', [Validators.required, Validators.email]],
      passwordRegister: ['', [Validators.required, Validators.minLength(6)]],
      confirmpasswordRegister: [
        '',
        [Validators.required, Validators.minLength(6)],
      ],
    });
    this.forgotPasswordForm = this.formBuilder.group({
      emailForgotPassword: ['', [Validators.required, Validators.email]],
    });

    // TODO To be implemented when we want to include the country combo box
    // this.countryFormGroup = this.formBuilder.group({
    //   country: [],
    // });

    this.webSearchForm = this.formBuilder.group({
      name: [''],
      location: [''],
    });

    this.mobileSearchForm = this.formBuilder.group({
      name: [''],
      location: [''],
      date: [''],
      category: [''],
    });

    //check if isLoggedin
    if (localStorage.getItem('user')) {
      this.isLoggedIn = true;
      let user = JSON.parse(this.encDecrService.decryptJsonDataFromStorage('user'))
      this.userType = user.user_type;
    }

    // -----------------------------------------------------------------------
    // SETTING CALENDER
    // -----------------------------------------------------------------------
    let now = new Date();
    this.selectMonth(now.getMonth() + 1);
    this.selectedYear = now.getFullYear();
    // Fill List Of All Years
    for (let y = this.minYear; y <= this.selectedYear + 1; y++)
      this.listOfAllYears.push(y);
    //display days
    this.displayDaysOfMonth();

    // -------------------------------------------------------------------------
    // API CALLS
    // -------------------------------------------------------------------------
    // Get All Categories to display them
    await this.categoryService
      .getAllCategories()
      .then((res: any) => {
        if (res.success) {
          let other;
          let result: any[] = res.categories;
          for (let i = 0; i < result.length; i++) {
            if(result[i].name.toLocaleLowerCase() !='other')
            {
              this.categories.push({
                id: result[i].id,
                name: result[i].name,
              });
            }
            else{
                  other={
                    id:result[i].id,
                    name: result[i].name
                  }
            }
          }
          this.categories.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          this.categories.push(other)
        } else {
          console.log(res.error);
        }
      })
      .catch((error) => {
        console.log(error);
      }); // end get all categories

    // TODO To be implemented when we want to include the country combo box
    // //Get COUNTRIES to display them in the comboBox
    // await this.appService.getCountries().then(async (res: any) => {
    //   if (res.success) {
    //     for (let i = 0; i < res.countries.length; i++) {
    //       this.predefinedCountries.push({
    //         name: res.countries[i].countryname,
    //         alpha2Code: res.countries[i].code,
    //         alpha3Code: res.countries[i].countrycode,
    //         numericCode: res.countries[i].id,
    //       });
    //     }
    //     //Get USER IP ADDRESS
    //     await this.appService
    //       .getIpAddress()
    //       .then(async (res: any) => {
    //         //GET USER COUNTRY
    //         await this.appService
    //           .getGEOLocation(res.ip)
    //           .then((res: any) => {
    //             this.predefinedCountries.find((predCountry) => {
    //               if (
    //                 predCountry.name.toLocaleLowerCase() ==
    //                 res.country_name.toLocaleLowerCase()
    //               ) {
    //                 this.countryFormGroup.get('country').setValue(predCountry);
    //                 this.country = predCountry.numericCode;
    //                 localStorage.setItem(
    //                   'Selected-Country',
    //                   JSON.stringify(predCountry)
    //                 );
    //                 localStorage.setItem(
    //                   'alpha2Code',
    //                   JSON.stringify(predCountry.alpha2Code)
    //                 );
    //                 this.options.componentRestrictions.country = 'LB';
    //               }
    //             });
    //           })
    //           .catch((error) => {
    //             console.log(error);
    //           }); //end getGEOLocation
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       }); //end getIpAddress
    //   }
    // }); //end get countries

    // TODO To be implemented when we want to include the country combo box
    // Subscribe on country change event
    // this.countriesSubscribtion = this.countryFormGroup
    //   .get('country')
    //   .valueChanges.subscribe((country) => {
    //     this.country = country.numericCode;
    //     this.getDefaultEvents();
    //     localStorage.setItem('Selected-Country', JSON.stringify(country));
    //     localStorage.setItem('alpha2Code', JSON.stringify(country.alpha2Code));
    //   });

    // Get default events to display them.
    this.getDefaultEvents();

    if(localStorage.getItem('events')){
      this.allEvents = JSON.parse(localStorage.getItem('events'))
      
    }

    this._dateRangeEventsListener = this.storageListenerService.watchStorage().subscribe((data: any) => {
      if (data == 'stored date range') {
        this.dateRange = JSON.parse(localStorage.getItem('date_range'))
        // console.log("FROM APP COMPONENT"+ this.dateRange)
        this.searchDateRange()
      }
    })

  }

  // ===========================================================================
  // ON DESTROY
  // ===========================================================================
  ngOnDestroy(): void {
    this._dateRangeEventsListener.unsubscribe()
    // TODO To be implemented when we want to include the country combo box
    // this.countriesSubscribtion.unsubscribe();
  }

  // ===========================================================================
  // On Year Change Function
  // ===========================================================================
  onYearChange(event) {
    this.startDate = ""
    this.endDate = ""
    
    this.checkRoute();
    this.selectedYear = event.value;
    this.selectMonth(1);
    this.displayDaysOfMonth();
    let searchOptions = this.getWebSearchOptions();
    let searchFor: SearchEvent = new SearchEvent();
    searchFor.name = searchOptions.name;
    searchFor.location = searchOptions.location;
    // TODO To be implemented when we want to include the country combo box
    // searchFor.country = this.country;
    searchFor.category = this.getSelectedCategory();
    searchFor.year = this.selectedYear;
    // searchFor.sortBy = sortOptions.sortby;
    searchFor.user_id = searchOptions.userID;
    // searchFor.sort_direction = sortOptions.sortOrder;
    searchFor.month = this.selectedMonth;
    this.getEvents(searchFor);
  }

  // ===========================================================================
  // On Month Change Function
  // ===========================================================================
  onMonthChange(inMonth: any) {
    this.startDate = ""
    this.endDate = ""
    
    this.checkRoute();
    this.selectMonth(inMonth.value);
    this.displayDaysOfMonth();
    let searchOptions = this.getWebSearchOptions();
    // let sortOptions = this.getSortOptions();
    let searchFor: SearchEvent = new SearchEvent();
    searchFor.name = searchOptions.name;
    searchFor.location = searchOptions.location;
    // TODO To be implemented when we want to include the country combo box
    // searchFor.country = this.country;
    searchFor.category = this.getSelectedCategory();
    let now = new Date();
    // this.selectMonth(now.getMonth() + 1);
    if(this.selectedYear != ""){
    searchFor.year = this.selectedYear;
    searchFor.month = this.selectedMonth;
  } else {
    this.selectedYear = now.getFullYear();
    searchFor.year = this.selectedYear
    }
    // searchFor.sortBy = sortOptions.sortby;
    searchFor.user_id = searchOptions.userID;
    // searchFor.sort_direction = sortOptions.sortOrder;
   
    this.getEvents(searchFor);
  }

  // =============================================================================
  // On Day Change Function
  // =============================================================================
  onDayChange(day: any) {
    this.startDate = ""
    this.endDate = ""
    
    this.checkRoute();
    this.selectDay(day);
    let searchOptions = this.getWebSearchOptions();
    // let sortOptions = this.getSortOptions();
    let searchFor: SearchEvent = new SearchEvent();
    searchFor.name = searchOptions.name;
    searchFor.location = searchOptions.location;
    // TODO To be implemented when we want to include the country combo box
    // searchFor.country = this.country;
    searchFor.category = this.getSelectedCategory();
    let now = new Date();
    if (this.selectedYear != "" && this.selectedMonth != ""){
      searchFor.year = this.selectedYear;
      searchFor.month = this.selectedMonth;
      
    } else {
      this.selectedYear = now.getFullYear();
      // this.selectedMonth = this.selectMonth(now.getMonth() + 1);
      this.selectedMonth = now.getMonth() + 1
      searchFor.year = this.selectedYear;
      searchFor.month = this.selectedMonth;
    }
    searchFor.day = this.selectedDay;
    // searchFor.sortBy = sortOptions.sortby;
    searchFor.user_id = searchOptions.userID;
    // searchFor.sort_direction = sortOptions.sortOrder;
    this.getEvents(searchFor);
  }

  // ===========================================================================
  // The following function get the selected/current year/month and display the
  // list of days in the calender
  // ===========================================================================
  displayDaysOfMonth() {
    this.listOfDaysOfTheSelectedMonth = [];
    const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    const daysInMonth = new Date(
      this.selectedYear,
      this.selectedMonth,
      0
    ).getDate();
    for (let i = 1; i <= daysInMonth; i++) {
      var d = new Date(this.selectedYear, this.selectedMonth - 1, i);
      var dayInName = days[d.getDay()];
      this.listOfDaysOfTheSelectedMonth.push({
        dayNumber: i,
        dayName: dayInName,
        isSelected: false,
      });
    }
  }

  // ===========================================================================
  // Controle the month design on the calender and save the selected month value
  // ===========================================================================
  selectMonth(monthValue) {
    this.allMonths.forEach((month) => {
      if (month.value == monthValue) {
        this.selectedMonth = month.value;
        this.selectedDay = '';
        month.isSelected = true;
      } else if (month.isSelected == true) {
        month.isSelected = false;
      }
    });
  }

  // ===========================================================================
  // Controle the day design on the calender and save the selected day value
  // ===========================================================================
  selectDay(inDay) {
    this.listOfDaysOfTheSelectedMonth.forEach((day) => {
      if (inDay.dayNumber == day.dayNumber) {
        this.selectedDay = day.dayNumber;
        day.isSelected = true;
      } else {
        day.isSelected = false;
      }
    });
  }

  // ===========================================================================
  // Get the address input from user and store it in our variable
  // ===========================================================================
  public handleAddressChange(address: Address) {
    this.webSearchForm.get('location').setValue(address.formatted_address);
  }

  // =============================================================================
  // Seach for event name or location taking into consideration the day/month/year
  // and all other parameters like country, category and sorting...
  // So the following search is an AND/OR condistion between params
  // =============================================================================
  async webSearchEvents() {
    this.startDate = ""
    this.endDate = ""
    this.search = true
    
    if (
      this.webSearchForm.get('name').value != '' 
      // || this.webSearchForm.get('location').value != ''
    ) {
      this.checkRoute();
      let searchOptions = this.getWebSearchOptions();
      // let sortOptions = this.getSortOptions();
      let searchFor: SearchEvent = new SearchEvent();
      searchFor.name = searchOptions.name;
      searchFor.location = '';
      this.selectedCategory = 0;
      this.selectedCategoryName = "All Events";
      searchFor.category = this.getSelectedCategory();
      // TODO To be implemented when we want to include the country combo box
      // searchFor.country = this.country;
      searchFor.category = 'all';
      searchFor.year = '';
      // searchFor.sortBy = sortOptions.sortby;
      searchFor.user_id = searchOptions.userID;
      // searchFor.sort_direction = sortOptions.sortOrder;
      searchFor.month = '';
      searchFor.day = '';
    
      
      this.selectedMonth = '';
      this.selectedYear = '';
      this.selectedDay = '';
      this.allMonths.forEach((months)=>{
          months.isSelected = false
      })
      this.listOfDaysOfTheSelectedMonth.forEach((day)=>{
        day.isSelected = false
    })
    this.selectedCategory = 0;
    await this.getEvents(searchFor).then((res)=>{
      this.storageListenerService.set('isSearch',true,'is search true')
    });
    // this.selectedCategoryName == 'All Categories'
    }
  }

  mobileSearchEvents() {
    this.startDate = ""
    this.endDate = ""
    this.search = true

    if (
      this.mobileSearchForm.get('name').value != '' ||
      this.mobileSearchForm.get('location').value != '' ||
      this.mobileSearchForm.get('date').value != '' ||
      this.mobileSearchForm.get('category').value != ''
    ) {
      this.checkMobileDate();
      this.checkRoute();
      let searchOptions = this.getMobileSearchOptions();
      // let sortOptions = this.getSortOptions();
      let searchFor: SearchEvent = new SearchEvent();
      searchFor.name = searchOptions.name;
      searchFor.location = '';
      // TODO To be implemented when we want to include the country combo box
      // searchFor.country = this.country;
      searchFor.category = '';
      searchFor.year = '';
      // searchFor.sortBy = sortOptions.sortby;
      searchFor.user_id = searchOptions.userID;
      // searchFor.sort_direction = sortOptions.sortOrder;
      searchFor.month = '';
      searchFor.day = '';
      this.getEvents(searchFor);
    }
  }

  // ===========================================================================
  // Clear search form
  // ===========================================================================
  resetSearch() {
    if (
      this.mobileSearchForm.get('name').value != '' ||
      this.mobileSearchForm.get('location').value != '' ||
      this.mobileSearchForm.get('date').value != '' ||
      this.mobileSearchForm.get('category').value != ''
    ) {
      this.mobileSearchForm.get('name').setValue('');
      this.mobileSearchForm.get('location').setValue('');
      this.mobileSearchForm.get('date').setValue('');
      this.mobileSearchForm.get('category').setValue('');
      let now = new Date();
      this.selectedYear = now.getFullYear();
      this.selectedMonth = now.getMonth() + 1;
      this.getDefaultEvents();
    }
  }

  // =============================================================================
  // Get events of the selected option with search and sort applied
  // =============================================================================
  selectCategory(id, categoryName) {
    this.checkRoute();
    this.selectedCategory = id;
    this.selectedCategoryName = categoryName;
    let searchOptions = this.getWebSearchOptions();
    // let sortOptions = this.getSortOptions();
    let searchFor: SearchEvent = new SearchEvent();
    searchFor.name = searchOptions.name;
    searchFor.location = searchOptions.location;
    // TODO To be implemented when we want to include the country combo box
    // searchFor.country = this.country;
    searchFor.category = this.getSelectedCategory();
    searchFor.year = this.selectedYear;
    // searchFor.sortBy = sortOptions.sortby;
    searchFor.user_id = searchOptions.userID;
    // searchFor.sort_direction = sortOptions.sortOrder;
    searchFor.month = this.selectedMonth;
    searchFor.day = this.selectedDay;
    this.getEvents(searchFor);
  }

  // =============================================================================
  // Save events in arrays (BY TYPE)
  // =============================================================================
  async storeEvents(res) {
    this.allEvents = [];
    this.standardEvents = [];
    this.featuredEvents = [];
    this.sponsoredEvents = [];
    for (let i = 0; i < res.events.data.length; i++) {
      this.allEvents.push(res.events.data[i])
      // switch (res.events.data[i].type) {
      //   case this.EVENT_TYPE_SPONSORED.toLocaleLowerCase(): {
      //     this.sponsoredEvents.push(res.events.data[i]);
      //     break;
      //   }
      //   case this.EVENT_TYPE_FEATURED.toLocaleLowerCase(): {
      //     this.featuredEvents.push(res.events.data[i]);
      //     break;
      //   }
      //   default: {
      //     this.standardEvents.push(res.events.data[i]);
      //     break;
      //   }
      // }
    }
    // console.log(this.featuredEvents)
    

    if (this.webSearchForm.get('name').value == ''){


    this.userAds=[]
    this.adminAds=[]
    await this.adsService.getAllAdsUser().then((res:any) => {
      this.userAds=res.ads.data
    })
    for (let i=0;i<res.ads.data.length; i++){
      this.adminAds.push(res.ads.data[i])
    }
    this.allAds = this.userAds.concat(this.adminAds)
     this.allAds = this.allAds.map(item => ({
      ...item,
      type:"ad",
    }));
    this.shuffledAds = this.shuffle(this.allAds)

    if(res.events.data.length>= 4)this.allEvents.splice(4, 0, this.shuffledAds[0]);
    
    if(res.events.data.length>= 13)this.allEvents.splice(13, 0, this.shuffledAds[1]);

    await this.sponsoredEventsService.getAllSponsoredEvents().then((res:any) => {
      let sponsored = res.events.data
      for(let i=0; i<sponsored.length; i++){
        this.sponsoredEvents.push(sponsored[i].event)
        this.sponsoredEvents[i].type = "featured"
      }
       this.allEvents = [
    ...this.sponsoredEvents,
    ...this.allEvents,
  ];
    })
    }

   

    this.storageListenerService.set(
      'eventsTitle',
      this.eventsTitle,
      'stored events title'
    );
    await this.storageListenerService.set('events', this.allEvents, 'stored events');
    localStorage.setItem('eventsTitle',this.eventsTitle);
    // this.setBannerSetting();
  }

  // =============================================================================
  // Get events with the default setting
  // =============================================================================
  getDefaultEvents() {
    this.spinner.show();
    this.selectedCategory = 0;
    let userID = this.getUserId();
    let searchFor: SearchEvent = new SearchEvent();
    // TODO To be implemented when we want to include the country combo box
    // searchFor.country = this.country;
    searchFor.year = this.selectedYear;
    searchFor.user_id = userID;
    
    let now = new Date()
    let currentMonth = now.getMonth()+1
    let currentDay = now.getDate()
    let currentYear = now.getFullYear()
    let lastDay 
 
    searchFor.month = this.selectedMonth;

    const daysInMonth = new Date(
      currentYear,
      currentMonth,
      0
    ).getDate();
    for (let i = 1; i <= daysInMonth; i++) {
      lastDay = i
    }
    let finalStart = currentYear + "-" + currentMonth + "-" + currentDay
    let finalEnd = currentYear + "-" + currentMonth + "-" + lastDay
    searchFor.start_date = finalStart
    searchFor.end_date = finalEnd

    this.eventsService
      .getAllEvents(searchFor)
      .then((res: any) => {
        this.eventsTitleControle(
          res.events.data.length
        );
        if (res.success) {
          this.eventsTitleControle(
            res.events.data.length
          );
          this.storeEvents(res);
        } else {
          alert(res.error);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => this.spinner.hide());
  }

  // ===========================================================================
  // Get events with all search settings
  // ===========================================================================
  async getEvents(searchFor) {
    //TODO IMPLEMENT THE SORT FEATURE
    this.spinner.show();
    await this.eventsService
      .getAllEvents(searchFor)
      .then((res: any) => {
        this.eventsTitleControle(
          res.events.data.length,
          searchFor.name,
          searchFor.location,
          this.selectedCategoryName
        );
        this.storeEvents(res);
        this.spinner.hide();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // ===========================================================================
  // On click today button
  // ===========================================================================
  getCurrentDateEvents() {
    this.checkRoute();
    if (
      this.currentDate.getFullYear() != this.selectedYear ||
      this.currentDate.getMonth() + 1 != this.selectedMonth ||
      this.currentDate.getDate() != this.selectedDay
    ) {
      this.selectedYear = this.currentDate.getFullYear();
      this.selectMonth(this.currentDate.getMonth() + 1);
      this.displayDaysOfMonth();
      this.selectDay({ dayNumber: this.currentDate.getDate() });
      let searchOptions = this.getWebSearchOptions();
      // let sortOptions = this.getSortOptions();
      let searchFor: SearchEvent = new SearchEvent();
      searchFor.name = searchOptions.name;
      searchFor.location = searchOptions.location;
      // TODO To be implemented when we want to include the country combo box
      // searchFor.country = this.country;
      searchFor.category = this.getSelectedCategory();
      searchFor.year = this.selectedYear;
      // searchFor.sortBy = sortOptions.sortby;
      searchFor.user_id = searchOptions.userID;
      // searchFor.sort_direction = sortOptions.sortOrder;
      searchFor.month = this.selectedMonth;
      searchFor.day = this.selectedDay;
      this.getEvents(searchFor);
    }
  }

  // ===========================================================================
  // Shufle an array
  // ===========================================================================
  shuffle(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  // =============================================================================
  // Get search options (NAME, LOCATION) FOR WEB
  // =============================================================================
  getWebSearchOptions() {
    let userID: string = '';
    if (localStorage.getItem('user')) {
      userID = JSON.parse(
        this.encDecrService.decryptJsonDataFromStorage('user')
      ).id;
    }
    return {
      name: this.webSearchForm.get('name').value,
      location: this.webSearchForm.get('location').value,
      userID: userID,
    };
  }

  // ===========================================================================
  // Controle events title
  // ===========================================================================
  eventsTitleControle(length, name?, location?, category?) {
    switch (length) {
      case 0: {
        this.eventsTitle = 'No Search Results ';
        if (this.checkName(name)) {
          this.eventsTitle += 'for "' + name + '"';
        }
        if (this.checkCategory(category)) {
          this.eventsTitle += ' for ' + category + ' category';
        }
        this.eventsTitle += ' in Lebanon '
        // if (this.checkLocation(location)) {
        //   this.eventsTitle += ' in "' + location + '"';
        // } else {
        //   this.eventsTitle +=
        //     ' in ' + JSON.parse(localStorage.getItem('Selected-Country')).name;
        // }
        if (this.startDate != "" && this.endDate != ""){
          this.eventsTitle += ' between ' + this.startDate + ' and ' + this.endDate
        }
        else if (this.selectedDay != '') {
          let month;
          this.allMonths.forEach((months)=>{
            if(months.value == this.selectedMonth)
              month = months.fullName
          })
          let date = new Date(
            this.selectedYear,
            this.selectedMonth - 1,
            this.selectedDay
          ).toDateString();
          let res = date.slice(0, 3);
          let day
          for(let i=0; i<this.daysOfWeek.length; i++){
            if (this.daysOfWeek[i].value == res ){
                day = this.daysOfWeek[i].name
            }
          }
          if(res)
          this.eventsTitle += ' on '+day+ ' '+ month+ ' '+ this.selectedDay +', '+ this.selectedYear;
        } else if (this.selectedMonth != '' || this.selectedYear != ''){
          let month;
          this.allMonths.forEach((months)=>{
            if(months.value == this.selectedMonth)
              month = months.fullName
          })
          this.eventsTitle += ' in ' + month + ' ' + this.selectedYear
        }
        break;
      }
      case 1: {
        this.eventsTitle = length + ' ';
        if (this.checkCategory(category)) {
          this.eventsTitle += category + ' Event';
        } else {
          this.eventsTitle += ' Event ';
        }
        this.eventsTitle += ' in Lebanon '
        if (this.checkName(name)) {
          this.eventsTitle += ' for "' + name + '"';
        }
        // if (this.checkLocation(location)) {
        //   this.eventsTitle += ' in "' + location + '"';
        // } else {
        //   this.eventsTitle +=
        //     ' in ' + JSON.parse(localStorage.getItem('Selected-Country')).name;
        // }
        if (this.startDate != "" && this.endDate != ""){
          this.eventsTitle += ' between ' + this.startDate + ' and ' + this.endDate
        }
        else if (this.selectedDay != '') {
          let month;
          this.allMonths.forEach((months)=>{
            if(months.value == this.selectedMonth)
              month = months.fullName
          })
          let date = new Date(
            this.selectedYear,
            this.selectedMonth - 1,
            this.selectedDay
          ).toDateString();
          let res = date.slice(0, 3);
          let day
          for(let i=0; i<this.daysOfWeek.length; i++){
            if (this.daysOfWeek[i].value == res ){
                day = this.daysOfWeek[i].name
            }
          }
          if(res)
          this.eventsTitle += ' on '+day+ ' '+ month+ ' '+ this.selectedDay +', '+ this.selectedYear;
        } else if (this.selectedMonth != '' || this.selectedYear != ''){
          let month;
          this.allMonths.forEach((months)=>{
            if(months.value == this.selectedMonth)
              month = months.fullName
          })
          this.eventsTitle += ' in ' + month + ' ' + this.selectedYear
        }
        break;
      }
      default: {
        this.eventsTitle = length + ' ';
        if (this.checkCategory(category)) {
          this.eventsTitle += category + ' Events ';
        } else {
          this.eventsTitle += ' Events ';
        }
        this.eventsTitle += ' in Lebanon '
        if (this.checkName(name)) {
          this.eventsTitle += ' for "' + name + '"';
        }
        // if (this.checkLocation(location)) {
        //   this.eventsTitle += ' in "' + location + '"';
        // } else {
        //   this.eventsTitle +=
        //     ' in ' + JSON.parse(localStorage.getItem('Selected-Country')).name;
        // }
        if (this.startDate != "" && this.endDate != ""){
          this.eventsTitle += ' between ' + this.startDate + ' and ' + this.endDate
        }
        else if (this.selectedDay != '') {
          let month;
          this.allMonths.forEach((months)=>{
            if(months.value == this.selectedMonth)
              month = months.fullName
          })
          let date = new Date(
            this.selectedYear,
            this.selectedMonth - 1,
            this.selectedDay
          ).toDateString();
          let res = date.slice(0, 3);
          let day
          for(let i=0; i<this.daysOfWeek.length; i++){
            if (this.daysOfWeek[i].value == res ){
                day = this.daysOfWeek[i].name
            }
          }
          if(res)
          this.eventsTitle += ' on '+day+ ' '+ month+ ' '+ this.selectedDay +', '+ this.selectedYear;
        } else if (this.selectedMonth != '' || this.selectedYear != ''){
          let month;
          this.allMonths.forEach((months)=>{
            if(months.value == this.selectedMonth)
              month = months.fullName
          })
          this.eventsTitle += ' in ' + month + ' ' + this.selectedYear
        }
        break;
      }
    }
  }

  // =============================================================================
  // Get search options (NAME, LOCATION, DATE & CATEGORY) FOR MOBILE
  // =============================================================================
  getMobileSearchOptions() {
    let userID: string = '';
    if (localStorage.getItem('user')) {
      userID = JSON.parse(
        this.encDecrService.decryptJsonDataFromStorage('user')
      ).id;
    }
    return {
      name: this.mobileSearchForm.get('name').value,
      location: this.mobileSearchForm.get('location').value,
      date: this.mobileSearchForm.get('date').value,
      category: this.mobileSearchForm.get('category').value,
      userID: userID,
    };
  }

  // ===========================================================================
  // Get the selected category
  // ===========================================================================
  getSelectedCategory() {
    if (
      this.selectedCategory == null ||
      this.selectedCategory == '' ||
      this.selectedCategory == 0
    ) {
      return 'all';
    }
    return this.selectedCategory;
  }

  // ===========================================================================
  // Get name of the selected category
  // ===========================================================================
  getSelectedCategoryName() {
    if (
      this.selectedCategoryName == null ||
      this.selectedCategoryName == '' ||
      this.selectedCategoryName == 0 ||
      this.selectedCategoryName == 'All Categories'
    ) {
      return '';
    }
    return this.selectedCategoryName;
  }
  // =============================================================================
  // Get userId from localstorage if user is loggedin
  // =============================================================================
  getUserId() {
    let userID: string = '';
    if (localStorage.getItem('user')) {
      userID = JSON.parse(
        this.encDecrService.decryptJsonDataFromStorage('user')
      ).id;
    }
    return userID;
  }

  // ===========================================================================
  // Check if the name field in the search for is empty or no
  // ===========================================================================
  checkName(name): boolean {
    if (
      name !== null &&
      name !== '' &&
      name !== ' ' &&
      name !== 'null' &&
      name !== 'undefined' &&
      name !== undefined
    )
      return true;
    return false;
  }

  // ===========================================================================
  // Check if the category is all or specific one
  // ===========================================================================
  checkCategory(category): boolean {
    if (
      category !== 0 &&
      category !== 'All Events' &&
      category !== '0' &&
      category !== '' &&
      category !== ' ' &&
      category !== 'null' &&
      category !== 'undefined' &&
      category !== undefined
    )
      return true;
    return false;
  }

  // ===========================================================================
  // Check if the location field is empty or no
  // ===========================================================================
  checkLocation(location) {
    if (
      location !== null &&
      location !== '' &&
      location !== ' ' &&
      location !== 'null' &&
      location !== 'undefined' &&
      location !== undefined
    ) {
      return true;
    }
    return false;
  }

  checkRoute() {
    if (this.router.url != '/main') this.router.navigate(['/main']);
  }

  checkMobileDate(){
    if(this.mobileSearchForm.get('date').value != ''){
      let mobileDatePicker = new Date(this.mobileSearchForm.get('date').value)
      this.selectedDay = mobileDatePicker.getDate();
      this.selectedMonth =mobileDatePicker.getMonth()+1;
      this.selectedYear = mobileDatePicker.getFullYear();
    }
    else{
      let currentDateForMobile = new Date();
      this.selectedDay = currentDateForMobile.getDate();
      this.selectedMonth = currentDateForMobile.getMonth()+1;
      this.selectedYear = currentDateForMobile.getFullYear();
    }
  }

  // convenience getter for easy access to form fields
  get l() {
    return this.loginForm.controls;
  }
  get f() {
    return this.registerForm.controls;
  }
  get fp() {
    return this.forgotPasswordForm.controls;
  }

  onLogin() {
    this.loadingLogin = true;
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.loadingLogin = false;
      return;
    }
    if (this.submitted) {
      this.appService
        .login(this.loginForm)
        .then((res: any) => {
          if (res.success) {
            if (res.user.avatar != null && res.user.block == 1)
              this.userImage = res.user.avatar;
            this.encDexcService.encryptJsonDataToStorage(
              'user',
              JSON.stringify(res.user)
            );
            this.userType = res.user.user_type;
            this.encDecrService.encryptStringDataToStorage('user_type', res.user.user_type)
            this.isLoggedIn = true;
            this.hideLogin();
            this.loadingLogin = false;
      window.location.reload();

          } else {
            alert(res.error);
            this.loadingLogin = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  onRegister() {
    this.loadingRegister = true;
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    if (this.submitted) {
      this.appService
        .register(this.registerForm)
        .then((res: any) => {
          if (res.success) {
            this.hideRegister();
            alert('Please check your email to verify your account.');
            this.loadingRegister = false;
          } else {
            this.registerForm.get('passwordRegister').reset();
            this.registerForm.get('confirmpasswordRegister').reset();
            alert(res.error);
            this.loadingRegister = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  logout() {
    if (this.router.url != '/main') {this.router.navigate(['main'])
    .then(() => {
      window.location.reload();
    });
  }
  if (this.router.url == '/main') window.location.reload();
    localStorage.clear();
    this.isLoggedIn = false;
  }

  onForgotPassword() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      return;
    }
    this.appService
      .forgetPassword(this.forgotPasswordForm)
      .then((res: any) => {
        if (res.success) {
          this.hideForgotPassword();
          alert(res.message);
        } else {
          alert(res.error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  logInWithGoogle() {
    window.open('https://events.globalistic.tech/redirect/google', '_self');
  }

  logInWithFacebook() {
    window.open('https://events.globalistic.tech/redirect/facebook', '_self');
  }

  goToAddEventPage() {
    if (this.isLoggedIn === false) {
      this.showRegister();
    } else if (this.isLoggedIn === true) {
      this.router.navigate(['/addevent']);
    }
  }

  showLogin() {
    this.showLoginModal = true; // Show-Hide Modal Check
  }

  //Bootstrap Modal Close event
  hideLogin() {
    this.showLoginModal = false;
    this.submitted = false;
    this.loginForm.reset();
  }

  showRegister() {
    this.showRegisterModal = true; // Show-Hide Modal Check
  }

  //Bootstrap Modal Close event
  hideRegister() {
    this.showRegisterModal = false;
    this.submitted = false;
    this.registerForm.reset();
  }

  showForgotPassword() {
    this.showForgotPasswordModal = true;
  }

  hideForgotPassword() {
    this.showForgotPasswordModal = false;
    this.submitted = false;
    this.forgotPasswordForm.reset();
  }

  searchDateRange(){
    const start_date = new Date(this.dateRange[0])
    const end_date = new Date(this.dateRange[1])

    let finalStart = start_date.getFullYear() + "-" + (start_date.getMonth() + 1) + "-" + start_date.getDate()
    let finalEnd = end_date.getFullYear() + "-" + (end_date.getMonth() + 1) + "-" + end_date.getDate()
  
    let searchFor: SearchEvent = new SearchEvent();
    let searchOptions = this.getWebSearchOptions();
    searchFor.start_date = finalStart
    searchFor.end_date = finalEnd
    searchFor.name = searchOptions.name;
    searchFor.location = searchOptions.location;
    searchFor.category = this.getSelectedCategory();
    searchFor.user_id = searchOptions.userID;
    
    this.startDate = start_date.getDate() + "/" + (start_date.getMonth() + 1) + "/" +start_date.getFullYear() 
    this.endDate = end_date.getDate() + "/" + (end_date.getMonth() + 1) + "/" +end_date.getFullYear()
    this.getEvents(searchFor);
    finalStart = ""
    finalEnd = ""
      this.allMonths.forEach((months)=>{
          months.isSelected = false
      })
      this.listOfDaysOfTheSelectedMonth.forEach((day)=>{
        day.isSelected = false
    })
    
  }

  defaultSearch(){
    this.search = false
    this.webSearchForm.get('name').setValue('');
    let now = new Date();
    this.selectMonth(now.getMonth() + 1);
    this.selectedYear = now.getFullYear();
    this.getDefaultEvents()
    this.listOfDaysOfTheSelectedMonth.forEach((day) => {
        day.isSelected = false;
    });
    
  }

  navigateOrRefresh(){
    // if (this.router.url != '/main') this.router.navigate(['/main']);
    // else window.location.reload();
    this.router.navigate(['main'])
    .then(() => {
      window.location.reload();
    });
  }
  
}

// document.addEventListener('copy', (event) => {
//   const pagelink = `\n\nRead more at: ${document.location.href}`;
//   event.clipboardData.setData('text', document.getSelection() + pagelink);
//   event.preventDefault();
// });
